<template>
	<aside class="w-full overflow-hidden rounded-lg bg-white shadow-xl sm:flex sm:w-80 sm:flex-col">
		<!-- Cabeçalho !-->
		<header class="flex flex-none items-baseline gap-2 border-b border-gray-200 px-5 py-4">
			<h3 class="text-sm font-semibold text-gray-900">Rastreio</h3>
			<span v-if="hasEvents" class="text-xs text-gray-500">{{ events.length }}</span>
		</header>
		<!-- Eventos !-->
		<template v-if="hasEvents">
			<!-- A lista sai do fluxo no desktop (sm:absolute) para não definir a altura do
				 card: assim ele estica junto com o resumo e só entao a rolagem aparece !-->
			<div class="relative sm:min-h-0 sm:flex-1">
				<!-- Do mais recente para o mais antigo: o estado atual é o que se procura primeiro !-->
				<ol class="max-h-96 overflow-y-auto px-5 py-4 sm:absolute sm:inset-0 sm:max-h-none">
					<li v-for="(event, index) in events" :key="event.id || index" class="relative flex gap-3 pb-5 last:pb-0">
						<!-- Linha ligando os eventos !-->
						<span v-if="!isLast(index)" class="absolute left-1 top-3 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
						<!-- Marcador: só o evento atual é preenchido !-->
						<span class="relative mt-1.5 h-2 w-2 flex-none rounded-full ring-4 ring-white"
							  :class="index === 0 ? 'bg-turquoise' : 'bg-gray-300'"
							  aria-hidden="true"></span>
						<!-- Descrição !-->
						<div class="min-w-0 flex-1">
							<p class="text-sm text-gray-900" :class="index === 0 && 'font-semibold'">{{ title(event) }}</p>
							<p class="mt-0.5 text-xs text-gray-500">
								<time v-if="event.event_at">{{ $dayjs(event.event_at).format('DD/MM/YYYY HH:mm') }}</time>
								<template v-if="location(event)">
									<span class="px-1">·</span>
									<span>{{ location(event) }}</span>
								</template>
							</p>
							<p v-if="event.note" class="mt-1 text-xs text-gray-500">{{ event.note }}</p>
						</div>
					</li>
				</ol>
			</div>
		</template>
		<!-- Vazio !-->
		<template v-else>
			<p class="px-5 py-8 text-center text-xs text-gray-500">Esta remessa ainda não tem eventos de rastreio.</p>
		</template>
	</aside>
</template>

<script>
export default {
	name: "ShipmentTraceCard",
	props: {
		/**
		 * Eventos da remessa, na ordem cronológica que o backend entrega
		 */
		feed: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		/**
		 * Eventos do mais recente para o mais antigo
		 * @returns {Array}
		 */
		events() {
			return [...(this.feed ?? [])].reverse()
		},
		hasEvents() {
			return this.events.length > 0
		}
	},
	methods: {
		/**
		 * @param event { Object }
		 * @returns {string}
		 */
		title(event) {

			if (typeof event.title_locale === 'string') return event.title_locale

			return this.$localize(event.title_locale)
		},
		/**
		 * País e estado do evento, quando informados
		 * @param event { Object }
		 * @returns {string}
		 */
		location(event) {
			return [
				this.$data_get(event, 'country.alpha2'),
				this.$data_get(event, 'state.code')
			].filter(filled).join(' · ')
		},
		/**
		 * @param index { Number }
		 * @returns {boolean}
		 */
		isLast(index) {
			return index === this.events.length - 1
		}
	}
}
</script>
